import { DatastoreProvider, InstanceDashboard } from 'component/navigation/instance';
import { useInstanceConfig } from 'data/instance-config';
import { type RoutePath, useLocalSearchParams } from 'expo-router';

const moduleFn = () => import('feature/editorial-dash/editorial-dash-module');

export default function EditorialDashboardLayout() {
    const { siloKey } = useLocalSearchParams<Extract<RoutePath, `/[siloKey]/editorialdash/one/${string}`>>();
    const instanceConfig = useInstanceConfig({
        siloKey,
        structureKey: 'editorialdash',
        instanceKey: 'one',
        moduleFn,
    });
    return (
        <DatastoreProvider {...instanceConfig}>
            <InstanceDashboard />
        </DatastoreProvider>
    );
}
